import ReactInputMask from 'react-input-mask';
import React, { Component } from 'react';
import { Input } from 'antd';
import withFormItem from 'components/hocs/withFormItem';

@withFormItem
export default class InputComponent extends Component {
    onChange = (e) => {
        const { field: { name }, form: { setFieldValue } } = this.props;

        setFieldValue(
            name,
            e.target.value.replace(/[^\d]/g, '')
        );
    }

    render() {
        const { field: { name, value }, type, placeholder, disabled} = this.props;

        return (
          <ReactInputMask
            mask="+7 (999) 999-99-99"
            value={value}
            onChange={this.onChange}
            disabled={disabled}
          >
            { (inputProps) => <Input
                disabled={disabled || null}
                name={name}
                type={type}
                placeholder={placeholder}
                />
            }
          </ReactInputMask>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/MaskedPhoneInput.js